import { ArrowRight } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const CustomCakes = () => (
  <section id="custom-cakes" className="scroll-mt-24 bg-[#F4EFEB] py-24 sm:py-32" data-testid="custom-cakes-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <div className="arch-frame overflow-hidden">
          <img
            src="/images/custom.jpg"
            alt="Elegant custom cake made to order in San Diego"
            loading="lazy"
            className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
            data-testid="custom-cakes-image"
          />
        </div>
      </Reveal>

      <div className="lg:col-span-6 lg:col-start-7">
        <Reveal>
          <Chapter num="02" label="Custom Cakes" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl font-light leading-tight tracking-tight text-[#2D2422] sm:text-5xl">
            Made Just for You
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-[#5C4B47] sm:text-lg">
            Every celebration is different, and your cake should be too. Bella Bells Cakes creates
            custom cakes designed around your event, inspiration, colors, theme, and style.
          </p>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-[#5C4B47]">
            Submit your ideas through our cake inquiry form. After reviewing your request, we&rsquo;ll
            follow up personally with availability, design details, and a custom quote.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button onClick={() => scrollToId("#inquiry")} className="btn-primary mt-10" data-testid="custom-cakes-cta">
            Start Your Cake Inquiry <ArrowRight size={16} strokeWidth={1.5} />
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);

export default CustomCakes;
